import {
  BaseFieldMappingFieldProps,
  FieldMappingData,
} from '@components/text-editors/addons/field-mapping';
import { SingleField } from '@components/text-editors/addons/single-field';

import { FieldMappingPhoneListField } from './field-mapping-phone-list-field';

export type FieldMappingPhoneFieldProps = BaseFieldMappingFieldProps & {
  fieldMapText?: { title: string; description: string };
} & FieldMappingData;

export const FieldMappingPhoneField = ({
  defaultValue,
  onChange,
  ...rest
}: FieldMappingPhoneFieldProps) => (
  <FieldMappingPhoneListField
    extensions={[SingleField]}
    defaultValue={defaultValue ? [defaultValue] : undefined}
    onChange={(value) => onChange?.(value[0])}
    {...rest}
  />
);
